<rk-stepper [@fadeInOut] [customNextStep]="postAppConfig"></rk-stepper>
<div class="simulator-container">
  <rk-app-configuration-shell></rk-app-configuration-shell>
</div>
